// Libraries
var React = require('react');
var $ = require('jquery');
var sneakpeek = require('sneakpeek');

// Styles
require('./ScrollBackTop.scss');

// Assets
var arrowWhite = require('images/arrow-up-white.svg');
var image = require('images/back-to-top.svg');

class ScrollBackTopModule extends React.Component {
	componentDidMount() {
		sneakpeek(this.btn);

		if (typeof window === "undefined") return;

		if (window.location.hash) {

			this.btn.classList.add('sneakpeek--hidden');

		}

	}

	handleScrollBackTop(event) {
		$('html, body').animate({scrollTop: 0}, 250);
		$('.MainNavigation a:first').focus();
	}

	render() {
		return (
			<button className="scrollBackTop" onClick={this.handleScrollBackTop.bind(this)} ref={(btn) => { this.btn = btn; }}>
				<img className="scrollBackTop__img" src={image} alt="" />
				<span className="u-visually-hidden">Scroll back to the top of the page</span>
			</button>
		);
	}
}

module.exports = ScrollBackTopModule;



// WEBPACK FOOTER //
// ./src/components/Footer/ScrollBackTop/ScrollBackTopModule.js